<div class="markdown-viewer" #markdownContainer>
  <div class="markdown-content" [innerHTML]="renderedHtml"></div>
</div>
